import { styled } from "@mui/material";
import React from "react";
import { defaultActionFilter } from "../const";
import {
  getCurrentSizeProfile,
  responsiveFontSize,
} from "@common/components/Typography/style";

interface ActionIndicatorProps {
  type?: string;
}

const StyledSpan = styled("span")(({ theme }) => ({
  marginLeft: theme.spacing(1),
  fontSize: getCurrentSizeProfile().small,
  ...responsiveFontSize(theme, "small"),
}));

const ActionIndicator = (props: ActionIndicatorProps) => {
  const { type } = props;

  const action = defaultActionFilter.find((action) => action.type === type);
  return (
    <>
      {action?.icon}
      <StyledSpan>{action?.label}</StyledSpan>
    </>
  );
};

export default ActionIndicator;
